
import { BasicBackgroundComponent, EnvGlobalsHandler } from "@goodgamestudios/core";
import { BasicCustomCursor } from "@goodgamestudios/core";
import { BrowserUtil } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";

import { getLogger } from "@goodgamestudios/logger";

import Event = createjs.Event;
import TimerEvent = createjs.TimerEvent;
import { Poker2LayoutManager } from "./Poker2LayoutManager";
import { Poker2CustomCursor } from "./Poker2CustomCursor";

const logger = getLogger("Poker2BackgroundComponent");

export class Poker2BackgroundComponent extends BasicBackgroundComponent {
    private maxProgressFrame: number = 0;

    constructor(preloaderViewComponent: Library.PokerTitle.PokerTitle) {
        CONSTRUCTOR_HACK;
        super(preloaderViewComponent);
        //			initABTest();
    }

    //		private function initABTest():void
    //		{
    //			var test:ABTest = ABTestController.instance.getTest( StartscreenTest.TEST_ID );
    //			test.dataRequestTimeoutError.add( showOriginalScreen );
    //
    //			// check if test is ready (asynchron)
    //			if (!test.isReady)
    //			{
    //				test.testIsInitalized.add( switchStartscreen );
    //			}
    //			else if (test.isReady)
    //			{
    //				switchStartscreen();
    //			}
    //		}

    // private showOriginalScreen(): void {
    //     this.pokerTitle.mc_bg.bg.addChild(new Library.PokerTitle.PokerTitleBackgroundOriginal());
    // }

    //		private function switchStartscreen():void
    //		{
    //			var abTest:ABTest = ABTestController.instance.getTest( StartscreenTest.TEST_ID );
    //
    //			// check if ab-test has expired
    //			if (!abTest.isValid)
    //			{
    //				logger.info( "AB Test with the id: " + StartscreenTest.TEST_ID + " has expired. Show original bg image." );
    //
    //				// test has expired, show fallback/default background image
    //				pokerTitle.mc_bg.bg.addChild( new PokerTitleBackgroundOriginal());
    //				return;
    //			}
    //
    //			if (abTest.testCaseID == StartscreenTest.CASE_ID_ORIGINAL_SCREEN)
    //			{
    //				pokerTitle.mc_bg.bg.addChild( new PokerTitleBackgroundOriginal());
    //			}
    //			else if (abTest.testCaseID == StartscreenTest.CASE_ID_OPTIONAL_SCREEN)
    //			{
    //				pokerTitle.mc_bg.bg.addChild( new PokerTitleBackgroundOptional());
    //			}
    //		}

    protected init(): void {
        this.versionTextfield.text = this.env.versionText;
        this.versionTextfield.visible = this.env.showVersion;
        this.updateLoadingProgress(0);

        this.customCursor = new Poker2CustomCursor();
        this.customCursor.init();
        this.pokerTitle.addChild(this.customCursor.disp);
        this.pokerTitle.mc_progressBar.txt_progress.defaultCacheScale = 2;

        this.pokerTitle.mc_bg.mc_logo.allowFastGlow = false;
        this.pokerTitle.mc_bg.mc_logo.doCache();

        // bei Netzwerken und IE-Browser wird der CustomCursor aus Performancegründen nicht verwendet!
        // if (BrowserUtil.getBrowserName().indexOf("IE") >= 0 && this.env.loginIsKeyBased) {
        //    this.customCursor.hideForPerformance();
        // }
        Poker2LayoutManager.CANVAS_RESIZED_SIGNAL.add(this.bindFunction(this.onBackgroundResized));
    }

    public show(): void {
        // play animated background
        if (this.pokerTitle.mc_bg.mc_bg_title.mc_bg_animation) {
            this.pokerTitle.mc_bg.mc_bg_title.mc_bg_animation.play();
        }
    }

    public hide(): void {

        // stop animations
        if (this.pokerTitle.mc_bg.mc_bg_title.mc_bg_animation) {
            this.pokerTitle.mc_bg.mc_bg_title.mc_bg_animation.gotoAndStop(1);
        }
    }

    public showVersion(): void {
        this.versionTextfield.text = this.env.versionText;
        this.versionTextfield.visible = this.env.showVersion;
    }

    protected onProgressTimer(event: TimerEvent): void {
        if (this.progressBar.currentFrame < this.maxProgressFrame)
            this.progressBar.nextFrame();
        else
            this.progressBar.stop();
    }

    public updateLoadingProgress(percent: number): void {
        this.maxProgressFrame = int(this.progressBar.totalFrames * percent / 100);
    }

    private onBackgroundResized(): void {
        this.updatePosition();
    }

    public updatePosition(): void {
        if (this.background && this.background.stage) {

            // TODO HTML-5004 force scale to 1 until we scale up our assets
            this.background.scaleX = this.background.scaleY = MathBase.min((this.background.stage.stageHeight / 600), (this.background.stage.stageWidth / 800));
            var scaleFactor: number = this.background.scaleX;
            this.background.x = (this.background.stage.stageWidth - (800 * this.background.scaleX)) / 2;
            this.background.y = 0;

            this.progressBar.scaleX = this.progressBar.scaleY = scaleFactor;
            this.progressBar.x = (this.background.stage.stageWidth - (800 * this.background.scaleX)) / 2 + (800 * scaleFactor / 2);
            this.progressBar.y = 300 * scaleFactor;
        }
    }

    protected onRemovedFromStage(event: Event): void {
        if (this.customCursor.disp && this.customCursor.disp.parent)
            this.pokerTitle.removeChild(this.customCursor.disp);
    }

    public get scaleFactor(): number {
        return (this.background) ? this.background.scaleX : 1; //backgroundView.stage.stageWidth / 800;
    }

    private get pokerTitle(): Library.PokerTitle.PokerTitle {
        return this.disp as Library.PokerTitle.PokerTitle;
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    public set scaleFactor(value/*:Number*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicBackgroundComponent.prototype, "scaleFactor").set.call(this, value);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set env(value/*:IEnvironmentGlobals*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicBackgroundComponent.prototype, "env").set.call(this, value);
    }
}
